import { getPrintDefault } from "@/config";
import { baseUrl } from "@/requestConfig/baseUrl";
import axios from "@/requestConfig/intercept";
import { sum } from "@/utils/decimal";
import { ResPages, Response } from "../index.limit";
import { ResCwToken, ResGetAutoTicket, ZtInfo, AIAutoInvoices, CollectInvoice, CustomerInfo } from "./index.limit";
export * from "./index.limit";
const { cw, invoice, info } = baseUrl;

/**
 * 财务登录
 */
export const apiCwToken = (data: FormData): Promise<ResCwToken> => {
  return axios.post(`${cw}/connect/token`, data);
};

/** 发票统计 */
export const apiGetAutoTicket = (params: { period: number }) => {
  return axios.get(`${invoice}/AutoInvoice/TicketStatistic`, { params }).then((res: Response<ResPages<ResGetAutoTicket>>) => {
    const items = res.data;
    return {
      ...items,
    };
  });
};

/**
 * 账套信息
 */
export const apiZTBasicInfo = (token: string): Promise<Response<ZtInfo>> => {
  return axios.get(`${info}/Common/ZTBasicInfo`, {
    notToken: true,
    headers: {
      Authorization: token,
    },
  });
};

/** 获取打印设置 */
export const apiPrintSetting = (params: { printType: number }, date: number) => {
  return axios.get(`${info}/Common/PrintSetting`, { params }).then((res: { data: any }) => {
    const { id, printSettings } = res.data || getPrintDefault();
    return {
      id,
      printSettings,
    };
  });
};

/**
 * 发票采集
 */
export const BatchCollectInvoiceApi = (data: CollectInvoice) => {
  return axios.post(`${baseUrl.AiServer}/AIAutoAccount/BatchCollectInvoice`, data);
};
/**
 * 获取采集状态 和 时间
 */
export const GetAIAutoInvoicesApi = (params: AIAutoInvoices) => {
  return axios.get(`${baseUrl.AiServer}/AIAutoAccount/GetAIAutoInvoices`, { params });
};
/**
 * 第三方获取在线状态
 */
export const TPCustomerTelStatusApi = (data: { companyId: string; source: number; customerIds: string[] }) => {
  return axios.post(`${baseUrl.ThirdPartyTask}/ThirdPartyTask/TPCustomerTelStatus`, data);
};

/**
 * 切换通道
 */
export const TPEditLoginChannel = (data: { companyId: string; channel: number; tels: string[] }) => {
  return axios.post(`${baseUrl.ThirdPartyTask}/TaxAssistant/EditLoginChannel`, data);
};

/**
 * 账号设置登录(获取登录列表)
 */
export const GetLoginInfoApi = (params: { customerId: string }) => {
  return axios.get(`${baseUrl.ThirdPartyTask}/TaxAssistant/GetLoginInfo`, { params });
};

/**
 * 获取验证码弹框(获取任务发送时间)
 */
export const GetTaskSendTime = (params: { customerId: string; accountId: string }) => {
  return axios.get(`${baseUrl.ThirdPartyTask}/TaxAssistant/GetTaskSendTime`, { params });
};
/**
 *获取验证码弹框(获取任务发送时间)
 */
export const SendLoginTask = (params: { customerId: string; accountId: string }) => {
  return axios.get(`${baseUrl.ThirdPartyTask}/TaxAssistant/SendLoginTask`, { params });
};

/**
 * 获取验证码弹框 (确认登录)
 */
export const SaveCode = (data: { customerId: string; code: string; smsId: string; accountId: string }) => {
  return axios.post(`${baseUrl.ThirdPartyTask}/TaxAssistant/SaveCode`, data);
};

/**
 *获取客户信息
 */
export const GetCustomerInfo = (params: { customerId: string }) => {
  return axios.get(`${baseUrl.api}/customer/GetCustomerInfo`, { params });
};

/**
 * 修改客户开票内容，纳税人识别号
 */
export const setCustomerInfo = (data: CustomerInfo) => {
  return axios.post(`${baseUrl.api}/customer/GetCustomerInfo`, data);
};

/**
 * AI记账专用上传接口
 */
export const apiAiUploadFileOut = (data: FormData): Promise<Response<string>> => {
  return axios.post(`https://report.yundaizhang.com.cn/BankFileServiceNew/api/AiBankStatement/AiUploadFileOut`, data, {
    timeout: 60000 * 10,
    notToken: true,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

/**
 * 获取用户银行信息
 */
export const apiGetBankNumber = (data: { user_id: string; userinfo?: any; customerInfo?: any }): Promise<Response<{ bank_list: Array<{ BankName: string; BankNumber: string }> }>> => {
  return axios.post(`https://wqft.caiyoucloud.cn/api/user/get_bank_number`, data);
};
